import * as React from 'react';
import { connect } from 'react-redux';
import { pastOrders as actions } from './../../Actions';
import * as tracking from './../../Actions/analytics';
import { Text } from 'ilenia';
import { Modal } from '../../CommonUI';
import { Settings } from '../../Model';
import { integrationConfig } from '../../Api/configapiClient';

interface ModalProps {
    renderModal: boolean;
    productIdentificationOptions: string[];
    businessUnitId: string;
    setRenderModal: (renderModal: boolean) => void;
    onProductReviewsSettingChange: (selector: Settings) => void;
    onSettingsSave: () => void;
    startSync: () => void;
    track: (name: string, data: any) => void;
    sendPostMessage: () => void;
}

const ModalWrapper: React.SFC<ModalProps> = (props) => {
    function onMainActionButtonClick() {
        const skuSelector = props.productIdentificationOptions && props.productIdentificationOptions[1];
        props.onProductReviewsSettingChange({ skuSelector });
        props.onSettingsSave();
        integrationConfig(props.businessUnitId, { enableProductReviews: true });
        syncAndTrack();
    }

    function onClose() {
        syncAndTrack();
    }

    function syncAndTrack() {
        const { track, startSync, setRenderModal, sendPostMessage} = props;

        setRenderModal(false);
        track('Integration Button Clicked', {
            context: 'Ecommscript integration app',
            location: window.location.pathname,
            placement: 'Modal screen',
            action: 'Sync past orders clicked',
            name: 'sync-past-orders-button',
        });
        startSync();
        sendPostMessage();
    }
    return (
        <Modal
            isOpen={props.renderModal}
            mainActionButton={{
                children: <Text id="enhancedPastOrders.productReviewsModalYes"/>,
                onClick: onMainActionButtonClick,
            }}
            onClose={onClose}
            cancelText={<Text id="enhancedPastOrders.productReviewsModalSkip"/>}
            header={<React.Fragment><Text id="enhancedPastOrders.productReviewsModalTitle"/></React.Fragment>}
            closable={true}
        >
            <Text id="enhancedPastOrders.productReviewsModalText"/>
        </Modal>
    );
};

const mapStateToProps = (state: any) => ({
    renderModal: state.PastOrders.renderModal,
    source: state.App.source,
    businessUnitId: state.App.account.businessUnitId,
    productIdentificationOptions: state.App.productIdentificationOptions,
});

const mapDispatchToProps = (dispatch: any) => ({
    setRenderModal: (renderModal: boolean) =>
        dispatch(actions.setRenderModal(renderModal)),
    startSync: () => dispatch(actions.startSync()),
    track: (name: string, data: any) => dispatch(tracking.track(name, data)),
});

export const ModalComponent = connect(
    mapStateToProps,
    mapDispatchToProps
)(ModalWrapper);



// WEBPACK FOOTER //
// ./src/Components/EnhancedPastOrders/modalComponent.tsx